module.exports = __webpack_public_path__ + "img/comment-lighter.24264b26.svg";